enum ActionName {
    SET = 'SET',
    CREATE_USER = 'CreateUser',
    EDIT_USER = 'EditUser',
    DELETE_USER = 'DeleteUser'
}

export default ActionName;
